import { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { useEscapeAction } from "CrossFeatureComponents/MemberToolbar/stateHooks";
import FnrTypography from "FnrTypography";

import FnrSlides from "UI/FnrSlides";

import ActiveContentWrapper from "../ActiveContentWrapper";
import { useHeaderTextColor } from "../stateHooks";

import EndingLogo from "./EndingLogo";
import FlyingAirplane from "./FlyingAirplane";

const topContentConfig = [
  { value: EndingLogo, key: "endingLogo" },
  { value: FlyingAirplane, key: "flyingAirplane" },
];

const MessageSent = () => {
  const closeTimeout = useRef();
  const endingLogoTimeout = useRef();
  const [activeKey, setActiveKey] = useState("flyingAirplane");
  const textColor = useHeaderTextColor();
  const { prayerRequest } = useMemberToobarContext();
  const close = useEscapeAction();

  useEffect(() => {
    clearTimeout(closeTimeout.current);
    closeTimeout.current = setTimeout(close, 6000);
    return () => clearTimeout(closeTimeout.current);
  }, [close]);

  useEffect(() => {
    clearTimeout(endingLogoTimeout.current);
    endingLogoTimeout.current = setTimeout(
      () => setActiveKey("endingLogo"),
      2500
    );
    return () => clearTimeout(endingLogoTimeout.current);
  }, [close]);

  return (
    <ActiveContentWrapper>
      <MotionContainer>
        <FnrSlides
          components={topContentConfig}
          activeKey={activeKey}
          hideHeightMotion
          fullWidth
          variant="fade"
        />
      </MotionContainer>
      <TextWrapper>
        <FnrTypography
          color={textColor}
          data-cy="MemberToolbar_MessageSentMessage"
          type="copy"
          fontSize="xl"
        >
          Your {prayerRequest ? "prayer request" : "message"} is on its way!
        </FnrTypography>
      </TextWrapper>
    </ActiveContentWrapper>
  );
};

const MotionContainer = styled.div`
  display: flex;
  height: 104px;
  width: 100%;
  justify-content: center;
`;

const TextWrapper = styled.div`
  padding-bottom: 18px;
  text-align: center;
`;

export default MessageSent;
